var React = require('react');

function Email (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-777{fill:none;}")),React.createElement("title",{"key":1},"email"),React.createElement("path",{"fill":"currentColor","d":"M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM25.8,8,16,14.78,6.2,8ZM4,24V8.91l11.43,7.91a1,1,0,0,0,1.14,0L28,8.91V24Z","transform":"translate(0)","key":2}),React.createElement("rect",{"id":"_Transparent_Rectangle_","data-name":"<Transparent Rectangle>","className":"cls-777","width":"32","height":"32","key":3})]);
}

Email.defaultProps = {"id":"icon","viewBox":"0 0 32 32"};

module.exports = Email;

Email.default = Email;
